import {
  Action,
  Selector,
  StateContext,
  State,
  Store
} from '@ngxs/store';
import {
  RegisterIsCadastralUpdate,
  UpdateInvestorRepresentativeOnServer,
  UpdateInvestorRepresentative,
  AddAgent
} from '../actions/register.action';
import { AgentRegister } from '../../models/agents/agent-register';
import { RegistrationService } from '../../services/registration.service';

export class RegisterStateModel {
  isCadastralUpdate: boolean | false;
  agent: AgentRegister;
}

@State<RegisterStateModel>({
  name: 'register',
  defaults: {
    isCadastralUpdate: null,
    agent: null
  }
})
export class RegisterState {
  constructor(
    protected store: Store,
    protected registrationService: RegistrationService
  ) {}

  @Selector()
  static IsCadastralUpdate(state: RegisterStateModel) {
    return state.isCadastralUpdate;
  }

  @Action(RegisterIsCadastralUpdate)
  RegisterIsCadastralUpdate(
    { patchState }: StateContext<RegisterStateModel>,
    { isCadastralUpdate }: RegisterIsCadastralUpdate
  ) {
    patchState({ isCadastralUpdate: isCadastralUpdate });
  }

  @Action(UpdateInvestorRepresentativeOnServer)
  updateInvestorRepresentativeOnServer(
    { getState }: StateContext<RegisterStateModel>,
    { investorRepresentative }: UpdateInvestorRepresentativeOnServer
  ) {
    return this.registrationService.updateInvestorRepresentative(
      investorRepresentative
    );
  }

  @Action(UpdateInvestorRepresentative)
  updateInvestorRepresentative(
    { getState, patchState }: StateContext<RegisterStateModel>,
    { investorRepresentative }: UpdateInvestorRepresentative
  ) {
    const agent = getState().agent;
    agent.investorRepresentative = investorRepresentative;
    patchState({ agent });

    return this.store.dispatch(
      new UpdateInvestorRepresentativeOnServer(investorRepresentative)
    );
  }

  @Action(AddAgent)
  addAgent(
    { getState, patchState }: StateContext<RegisterStateModel>,
    { agent }: AddAgent
  ) {
    let agentState = getState().agent;

    if (agentState == null) {
      agentState = agent;
    }

    patchState({ agent: agentState });
  }
}
